// extracted by mini-css-extract-plugin
export var animationContainer = "_j6-0";
export var asteriskIcon = "_j6-8";
export var conversationLeftSection = "_j6-4";
export var conversationListItem = "_j6-3";
export var conversationMiddleSection = "_j6-5";
export var conversationRightSection = "_j6-6";
export var detailsContent = "_j6-1";
export var listContainer = "_j6-7";
export var modalContent = "_j6-2";